import { render, staticRenderFns } from "./iDSUpdatePwd.vue?vue&type=template&id=3f932e9c"
import script from "./iDSUpdatePwd.vue?vue&type=script&lang=js"
export * from "./iDSUpdatePwd.vue?vue&type=script&lang=js"
import style0 from "./iDSUpdatePwd.vue?vue&type=style&index=0&id=3f932e9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports